// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/section6.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.section6_container__MT4a2 {
  /*background-image: url(/public/images/outview3.png); */
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  backdrop-filter: grayscale(100%);
  display: flex;
  flex-direction: column;
  align-items: center; /* 세로 중앙 정렬 */
  padding: 5%;
}

.section6_parent__VzCDS {
  display: flex;                /* Flexbox로 배치 */
  flex-wrap: wrap;               /* 자식 div가 공간을 초과하면 자동으로 줄 바꿈 */
  gap: 0px;                     /* 자식 div들 간의 간격 */
  padding : 2%
}

/* 자식 div */
.section6_top__l0bzx {
  text-align: center;           /* 텍스트 중앙 정렬 */
  width : 100vw;
}


/* 자식 div */
.section6_child__cSLTw {
  flex: 26% 1;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */
  margin : 0.5%;
  text-align: center;           /* 텍스트 중앙 정렬 */
  box-sizing: border-box;       /* padding, border가 전체 크기에 포함되도록 설정 */
  background-color: white;
}

.section6_text-number__2N0V1 {
  font-size: 60px;
  color: #0c78B7;
  font-weight: 500;
}

.section6_text-box__ARldY {
  font-size: 34px;
  color: black;
  font-weight: 800;
}


.section6_text-small__LYTb5 {
  letter-spacing: 5px;
  font-size: 10px;
  color: white;
  margin-bottom: 5px;
}

.section6_text-mid__VFzT5 {
  font-size: 21px;
  color: gray;
  margin-bottom: 0px;
  margin-left: 10%;
  margin-right: 10%;
}

.section6_text-mid-top__jaK\\+\\+ {
  font-size: 22px;
  color: white;
  margin-bottom: 0px;
  margin-left: 10%;
  margin-right: 10%;
}

.section6_text-large__1Rue0 {
  margin-top: 0;
  font-size: 45px;
  color: white;
  font-weight: 500;
  margin-bottom: 30px;
}


@media (max-width: 1024px) {

  .section6_parent__VzCDS {
    gap: 20px;                     /* 자식 div들 간의 간격 */
    padding: 5%;
  }

  .section6_child__cSLTw {
    flex: 1 1 100%;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */
  }

  .section6_image__ExW0O {
    width : 100px;
  }

  .section6_text-number__2N0V1 {
    font-size: 40px;
    color: #0c78B7;
    font-weight: 500;
  }

  .section6_text-box__ARldY {
    font-size: 28px;
    color: black;
    font-weight: 400;
  }
  
  .section6_text-mid__VFzT5 {
    font-size: 16px;
    padding-bottom : 13%;
    padding-left: 8%;
    padding-right: 8%;
  }

  .section6_text-mid-top__jaK\\+\\+ {
    font-size: 14px;
  }

  .section6_text-large__1Rue0 {
    font-size: 36px;
  }
}

@media (min-width: 1025px) and (max-width: 1596px) {

  .section6_text-large__1Rue0 {
    font-size: 80px;
  }

  .section6_text-box__ARldY {
    font-size:20px;
  }
  
  .section6_text-mid__VFzT5 {
    font-size: 16px;
  }

  .section6_text-mid__VFzT5 {
    margin-bottom: 80px;
  }

  .section6_child__cSLTw {
    flex: 20% 1;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */
  }
  
}

@media (min-width: 1597px) {

  .section6_text-large__1Rue0 {
    font-size: 80px;
  }

  .section6_text-mid__VFzT5 {
    margin-bottom: 80px;
  }

  .section6_child__cSLTw {
    flex: 20% 1;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */
  }
  
}`, "",{"version":3,"sources":["webpack://./src/Sections/section6.module.css"],"names":[],"mappings":";AACA;EACE,uDAAuD;EACvD,4GAAuG;EACvG,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,aAAa;EAClC,WAAW;AACb;;AAEA;EACE,aAAa,iBAAiB,gBAAgB;EAC9C,eAAe,gBAAgB,+BAA+B;EAC9D,QAAQ,sBAAsB,kBAAkB;EAChD;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB,YAAY,cAAc;EAC5C,aAAa;AACf;;;AAGA,WAAW;AACX;EACE,WAAS,iBAAiB,sCAAsC;EAChE,aAAa;EACb,kBAAkB,YAAY,cAAc;EAC5C,sBAAsB,QAAQ,qCAAqC;EACnE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;;EAEE;IACE,SAAS,sBAAsB,kBAAkB;IACjD,WAAW;EACb;;EAEA;IACE,cAAc,cAAc,sCAAsC;EACpE;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAS,iBAAiB,sCAAsC;EAClE;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAS,iBAAiB,sCAAsC;EAClE;;AAEF","sourcesContent":["\n.container {\n  /*background-image: url(/public/images/outview3.png); */\n  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/public/images/section6.jpg');\n  background-size: cover;\n  background-position: center;\n  backdrop-filter: grayscale(100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* 세로 중앙 정렬 */\n  padding: 5%;\n}\n\n.parent {\n  display: flex;                /* Flexbox로 배치 */\n  flex-wrap: wrap;               /* 자식 div가 공간을 초과하면 자동으로 줄 바꿈 */\n  gap: 0px;                     /* 자식 div들 간의 간격 */\n  padding : 2%\n}\n\n/* 자식 div */\n.top {\n  text-align: center;           /* 텍스트 중앙 정렬 */\n  width : 100vw;\n}\n\n\n/* 자식 div */\n.child {\n  flex: 26%;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */\n  margin : 0.5%;\n  text-align: center;           /* 텍스트 중앙 정렬 */\n  box-sizing: border-box;       /* padding, border가 전체 크기에 포함되도록 설정 */\n  background-color: white;\n}\n\n.text-number {\n  font-size: 60px;\n  color: #0c78B7;\n  font-weight: 500;\n}\n\n.text-box {\n  font-size: 34px;\n  color: black;\n  font-weight: 800;\n}\n\n\n.text-small {\n  letter-spacing: 5px;\n  font-size: 10px;\n  color: white;\n  margin-bottom: 5px;\n}\n\n.text-mid {\n  font-size: 21px;\n  color: gray;\n  margin-bottom: 0px;\n  margin-left: 10%;\n  margin-right: 10%;\n}\n\n.text-mid-top {\n  font-size: 22px;\n  color: white;\n  margin-bottom: 0px;\n  margin-left: 10%;\n  margin-right: 10%;\n}\n\n.text-large {\n  margin-top: 0;\n  font-size: 45px;\n  color: white;\n  font-weight: 500;\n  margin-bottom: 30px;\n}\n\n\n@media (max-width: 1024px) {\n\n  .parent {\n    gap: 20px;                     /* 자식 div들 간의 간격 */\n    padding: 5%;\n  }\n\n  .child {\n    flex: 1 1 100%;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */\n  }\n\n  .image {\n    width : 100px;\n  }\n\n  .text-number {\n    font-size: 40px;\n    color: #0c78B7;\n    font-weight: 500;\n  }\n\n  .text-box {\n    font-size: 28px;\n    color: black;\n    font-weight: 400;\n  }\n  \n  .text-mid {\n    font-size: 16px;\n    padding-bottom : 13%;\n    padding-left: 8%;\n    padding-right: 8%;\n  }\n\n  .text-mid-top {\n    font-size: 14px;\n  }\n\n  .text-large {\n    font-size: 36px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1596px) {\n\n  .text-large {\n    font-size: 80px;\n  }\n\n  .text-box {\n    font-size:20px;\n  }\n  \n  .text-mid {\n    font-size: 16px;\n  }\n\n  .text-mid {\n    margin-bottom: 80px;\n  }\n\n  .child {\n    flex: 20%;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */\n  }\n  \n}\n\n@media (min-width: 1597px) {\n\n  .text-large {\n    font-size: 80px;\n  }\n\n  .text-mid {\n    margin-bottom: 80px;\n  }\n\n  .child {\n    flex: 20%;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section6_container__MT4a2`,
	"parent": `section6_parent__VzCDS`,
	"top": `section6_top__l0bzx`,
	"child": `section6_child__cSLTw`,
	"text-number": `section6_text-number__2N0V1`,
	"text-box": `section6_text-box__ARldY`,
	"text-small": `section6_text-small__LYTb5`,
	"text-mid": `section6_text-mid__VFzT5`,
	"text-mid-top": `section6_text-mid-top__jaK++`,
	"text-large": `section6_text-large__1Rue0`,
	"image": `section6_image__ExW0O`
};
export default ___CSS_LOADER_EXPORT___;
